import { FormikConsumer, Field } from 'formik';
import classNames from 'classnames';
import FormControl from './FormControl';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Radio extends Component {
  renderOptions = () => {
    return (
      this.props.options.map((item, index) =>
        <div className="usa-radio" key={index}>
          <Field
            type="radio"
            name={this.props.name}
            id={this.props.name + '.' + item.value}
            value={item.value} />
          <label htmlFor={this.props.name + '.' + item.value}>{item.label}</label>
        </div>
      )
    )
  };

  render() {
    return (
      <FormikConsumer>
        {({ errors, touched }) => (
          <FormControl label={this.props.label}
            hasError={errors[this.props.name] && touched[this.props.name]}
            className={classNames(
              'form-item-radios',
              this.props.className,
            )}
            name={this.props.name}>
            {this.renderOptions()}
          </FormControl>
        )}
      </FormikConsumer>
    );
  }
}

Radio.defaultProps = {
  className: [],
  options: [],
  label: '',
  value: '',
  validations: [],
  mapped: false
};

Radio.propTypes = {
  className: PropTypes.array,
  options: PropTypes.array,
  label: PropTypes.string,
  value: PropTypes.string,
  validations: PropTypes.array,
  mapped: PropTypes.bool
};

export default Radio;
